export const TOGGLE_USER_TAB_SWITCH_REQUEST = "TOGGLE_USER_TAB_SWITCH_REQUEST";
export const TOGGLE_USER_TAB_SWITCH_SUCCESS = "TOGGLE_USER_TAB_SWITCH_SUCCESS";
export const TOGGLE_USER_TAB_SWITCH_FAIL = "TOGGLE_USER_TAB_SWITCH_FAIL";
